import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import PageTabs from '../../ui/PageTabs';
import { t } from '../../utils/i18n';
import PushTestPage from './Push';
import PushSchedulePage from './PushSchedule';
import PushBroadcastPoliciesPage from './PushBroadcastPolicies';
import PushCatalog from './PushCatalog';
import { PushAuditHistory, PushDeliveryStatus } from './PushOperationsStatus';

/** Campaign/policy destinations share local tabs; delivery QA has its own tools entry. */
export default function PushSection() {
  const { pathname } = useLocation();
  const destinations = [['catalog', 'pushCatalog'], ['announcements', 'pushCampaigns'], ['delivery', 'pushDeliveryStatus'], ['limits', 'pushLimits'], ['history', 'pushHistory']];
  return (
    <div>
    {pathname !== '/push/test' && <div className="px-4 sm:px-6 lg:px-8"><PageTabs label={t('header.nav.push')} active={pathname.split('/')[2]} items={destinations.map(([id,key]) => ({id,to:`/push/${id}`,label:t(`header.nav.${key}`)}))} /></div>}
    <Routes>
      <Route index element={<Navigate to="/push/catalog" replace />} />
      <Route path="catalog" element={<PushCatalog />} />
      <Route path="delivery" element={<PushDeliveryStatus />} />
      <Route path="history" element={<PushAuditHistory />} />
      <Route path="limits" element={<PushBroadcastPoliciesPage />} />
      <Route path="test" element={<PushTestPage />} />
      <Route path="product-update" element={<Navigate to="/push/announcements" replace />} />
      <Route path="announcements" element={<PushSchedulePage />} />
      <Route path="schedule" element={<Navigate to="/push/announcements" replace />} />
      <Route path="recommendation" element={<Navigate to="/push/announcements" replace />} />
      <Route path="recommendation-schedule" element={<Navigate to="/push/announcements" replace />} />
      <Route path="delivery-policies" element={<Navigate to="/push/catalog" replace />} />
      <Route path="broadcast-policies" element={<Navigate to="/push/limits" replace />} />
    </Routes>
    </div>
  );
}
